import { Smartphone, Banknote } from "lucide-react";

const OPTIONS = [
  { id: "upi", label: "UPI", desc: "Pay the seller with GPay, PhonePe or any UPI app, then upload the screenshot.", icon: Smartphone },
  { id: "cod", label: "Cash on Delivery", desc: "Pay in cash when your order arrives. The seller is notified straight away.", icon: Banknote },
];

export const PaymentChoice = ({ method, setMethod, upiAvailable, onContinue, busy }) => (
  <div data-testid="payment-choice" className="space-y-4">
    <p className="eyebrow">Payment method</p>
    {OPTIONS.map(({ id, label, desc, icon: Icon }) => {
      const disabled = id === "upi" && !upiAvailable;
      return (
        <button
          key={id}
          data-testid={`payment-option-${id}`}
          disabled={disabled}
          onClick={() => setMethod(id)}
          className={`w-full text-left flex gap-4 p-5 border transition-colors ${method === id ? "border-[#0F0F0F] bg-white" : "border-[#0F0F0F]/15 hover:border-[#0F0F0F]/50"} disabled:opacity-40 disabled:cursor-not-allowed`}
        >
          <span className={`h-10 w-10 shrink-0 flex items-center justify-center ${method === id ? "bg-[#0F0F0F] text-[#C5A059]" : "bg-[#F5EFE6] text-[#0F0F0F]"}`}>
            <Icon className="h-5 w-5" strokeWidth={1.5} />
          </span>
          <span>
            <span className="block font-medium">{label}</span>
            <span className="block text-xs text-[#71717A] mt-1">{disabled ? "This seller hasn't set up UPI yet." : desc}</span>
          </span>
        </button>
      );
    })}
    <button
      data-testid="payment-continue-button"
      disabled={!method || busy}
      onClick={onContinue}
      className="w-full bg-[#0F0F0F] text-[#C5A059] py-4 text-xs tracking-[0.3em] uppercase disabled:opacity-40 transition-shadow hover:shadow-[0_0_30px_rgba(197,160,89,0.35)]"
    >
      {busy ? "Please wait…" : method === "cod" ? "Confirm order" : "Continue to UPI payment"}
    </button>
  </div>
);
